/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetadataItem
 */
export interface MetadataItem {
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof MetadataItem
     */
    customFields: { [key: string]: string | undefined; };
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof MetadataItem
     */
    tags: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {string}
     * @memberof MetadataItem
     */
    path: string;
}

export function MetadataItemFromJSON(json: any): MetadataItem {
    return MetadataItemFromJSONTyped(json, false);
}

export function MetadataItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetadataItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'customFields': json['custom_fields'],
        'tags': json['tags'],
        'path': json['path'],
    };
}

export function MetadataItemToJSON(value?: MetadataItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'custom_fields': value.customFields,
        'tags': value.tags,
        'path': value.path,
    };
}


